import service from '../service/gift'
import CONSTANT from '../constant/gift'
import OCONSTANT from '../constant/order'
import _ from 'underscore'
export default {
    getGiftOrderList ({commit}, data) {
        return new Promise((resolve, reject) => {
            return service.getGiftOrderList(data).then(result => {
                resolve(result)
                commit(CONSTANT.GIFT_GETGIFTORDERLIST_SUCCESS, result)
                return result
            }, e => {
                reject(e)
                commit(CONSTANT.GIFT_GETGIFTORDERLIST_ERROR, e)
            })
        })
    },
    getGiftOrderListMore ({commit}, data) {
        return new Promise((resolve, reject) => {
            return service.getGiftOrderList(data).then(result => {
                resolve(result)
                commit(CONSTANT.GIFT_GETGIFTORDERLIST_MORE_SUCCESS, result)
                return result
            }, e => {
                reject(e)
                commit(CONSTANT.GIFT_GETGIFTORDERLIST_MORE_ERROR, e)
            })
        })
    },
    getGiftOrderDetail ({commit}, data) {
        return new Promise((resolve, reject) => {
            return service.getGiftOrderDetail(data).then(result => {
                resolve(result)
                commit(OCONSTANT.ORDER_GET_DETAIL_SUCCESS, result)
                return result
            }, e => {
                reject(e)
                commit(OCONSTANT.ORDER_GET_DETAIL_ERROR, e)
            })
        })
    },
    getShareLink ({commit}, data) {
        return new Promise((resolve, reject) => {
            return service.getShareLink(data).then(result => {
                resolve(result)
                return result
            }, e => {
                reject(e)
            })
        })
    },
    receiveGift ({commit}, data) {
        return new Promise((resolve, reject) => {
            return service.receiveGift(data).then(result => {
                resolve(result)
                commit(CONSTANT.GIFT_RECEIVEGIFT_SUCCESS, result)
                return result
            }, e => {
                reject(e)
                commit(CONSTANT.GIFT_RECEIVEGIFT_ERROR, e)
            })
        })
    },
    getGiftreceiveInfo ({commit}, data) {
        return new Promise((resolve, reject) => {
            return service.getGiftreceiveInfo(data).then(result => {
                resolve(result)
                return result
            }, e => {
                reject(e)
            })
        })
    },
    deleteGiftProductInfo({commit}, data){
        commit(CONSTANT.GIFT_DELETE_PRODUCTS, data)
        return 
    },
    setGiftProductInfo({commit}, data){
        commit(CONSTANT.GIFT_SET_INFO, data)
        return 
    },
    cancelGiftOrder({commit}, data) {
        return new Promise((resolve, reject) => {
            return service.cancelGiftOrder(data).then(result => {
                resolve(result)
                return result
            }, e => {
                reject(e)
            })
        })
    },
    setGiftSkuInfo({commit}, data){
        commit(CONSTANT.GIFT_SET_SKU_INFO, data)
        return
    }
    /*yeoman-template-point-1*/
}
